import React, { useState, useEffect, useRef } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { Radio } from 'antd';
// import geoJson from './IndiaMapData.json'
import { mapOption as option, mpLeadsArray } from './Utils';
import { parseStateResultGroups } from './ApiUtils';
// import mpVotesData from './testing/TGMPVotes.json';
// import mlaVotesData from './testing/TGMLAVotes.json';

export default function IndiaMapChart(props) {

    let storedRadio = JSON.parse(localStorage.getItem('mapRadio'));
    const [mpMlaRadio, setMpMlaRadio] = useState(storedRadio ? storedRadio : 1);
    const [mapOption, setMapOption] = useState(false);

    let echartRef = useRef(null);
    let { group1List, group2List, partyLeadsMap, toolTipObj, stateMLAMap, stateMPMap,
        currentStateData, currentState, stateResults, isMpMla } = props;
    let { mp, mla } = isMpMla;

    useEffect(() => {
        console.log('Map use effect triggered. currentState=',currentState);
        if(currentState=='IN') {
            let geoJsonObj = stateMPMap;
            console.log('geoJsonObj=',geoJsonObj);
            echarts.registerMap('testing', geoJsonObj);
            let indiaLeadData = [], indiaToolTip = {};
            Object.keys(stateResults).map(key => {
                if(key!='leads') {
                    console.log('state key=',key);
                    let currentStateMpData = stateResults[key].mpData;
                    let { leadData, stateToolTip } = parseStateResultGroups(currentStateMpData, group1List, group2List);
                    indiaLeadData = [ ...indiaLeadData, ...leadData ];
                    indiaToolTip = { ...indiaToolTip, ...stateToolTip };
                    console.log('indiaLeadData=',indiaLeadData,' indiaToolTip=',indiaToolTip);
                }
            });
            let tempObj = { id: 'population', name: 'VOTEism Data', type: 'map', map: 'testing', roam: true,
                zoom: 1.1, emphasis: { disabled: true }, select: { disabled: true },
                data: indiaLeadData, notMerge: true, aspectScale: 1 };
            let tooltip = {
                borderWidth: 2,
                trigger: 'item',
                position: ['1%', '1%'],
                transitionDuration: 0.2,
                formatter: (params) => {
                    console.log('params=',params.name);
                    if(params.name&&indiaToolTip[params.name]) {
                        return `<b><h3>${params.name}</h3></b>${indiaToolTip[params.name]}<br />`;
                    }
                    return `<b><h3>${params.name}</h3></b>No votes yet.`;
                }
            }
            setMapOption({ ...option, tooltip: tooltip, series: [tempObj] });
        }
        else if(currentStateData) {
            console.log('Map currentStateData=',currentStateData);
            let { mlaData, mpData } = currentStateData;
            console.log('Going to display echart. leads=',partyLeadsMap,' group1List=', group1List, group2List);
            let { leadData, stateToolTip } = parseStateResultGroups(mpData, group1List, group2List);
            let leadsMLAMap = parseStateResultGroups(mlaData, group1List, group2List);
            let isMLA = mpMlaRadio==1;
            if(!mla) { isMLA = false; }
            let leadsMPMLAMap = isMLA ? leadsMLAMap.leadData : leadData;
            let toolTipMap = isMLA ? leadsMLAMap.stateToolTip : stateToolTip;
            // let leadsMPMLAMap = isMLA ? partyLeadsMap.mla : partyLeadsMap.mp;
            // let toolTipMap = isMLA ? toolTipObj.mla : toolTipObj.mp;
            let geoJsonObj = isMLA ? stateMLAMap : stateMPMap;
            console.log('isMLA=',isMLA,' geoJsonObj=',geoJsonObj);
            echarts.registerMap('testing', geoJsonObj);
            // let { leadData, stateToolTip } = mpLeadsArray(mpVotesData, group1List, group2List);
            // let leadsMLAMap = mpLeadsArray(mlaVotesData, group1List, group2List);
            // let leadsMPMLAMap = isMLA ? leadsMLAMap.leadData : leadData;
            // let toolTipMap = isMLA ? leadsMLAMap.stateToolTip : stateToolTip;
            // console.log('toolTipMap=',toolTipMap,' leadsMPMLAMap=',leadsMPMLAMap);
            let tempObj = { id: 'population', name: 'VOTEism Data', type: 'map', map: 'testing', roam: true,
                zoom: 1.1, emphasis: { disabled: true }, select: { disabled: true },
                data: leadsMPMLAMap, notMerge: true, aspectScale: 1 };
            let tooltip = {
                borderWidth: 2,
                trigger: 'item',
                position: ['1%', '1%'],
                transitionDuration: 0.2,
                formatter: (params) => {
                    console.log('params=',params.name);
                    if(params.name&&toolTipMap[params.name]) {
                        return `<b><h3>${params.name}</h3></b>${toolTipMap[params.name]}<br />`;
                    }
                    return `<b><h3>${params.name}</h3></b>No votes yet.`;
                }
            }
            setMapOption({ ...option, tooltip: tooltip, series: [tempObj] });
        }
    }, [mpMlaRadio, props]);

    const onMPMLAChange = (e) => {
        let value = e.target.value;
        console.log('mp mla radio checked', value);
        setMpMlaRadio(value);
        localStorage.setItem('mapRadio', JSON.stringify(value));
    }

    if(mapOption) {
        if((currentState=='IN')) {
            return (
                <div style={{ width: props.mapWidth, height: props.mapHeight }}>
                    <Radio.Group value={2}>
                        <Radio key={'mp'} value={2}>MP</Radio>
                    </Radio.Group>
                    <ReactEcharts option={mapOption} notMerge={true} lazyUpdate={true}
                    style={{ width: props.mapWidth, height: props.mapHeight }}
                    ref={(e) => { echartRef = e; }} />
                </div>
            );
        }
        return (
            <div style={{ width: props.mapWidth, height: props.mapHeight }}>
                {(mp&&mla)
                    ?
                    <Radio.Group onChange={onMPMLAChange} value={mpMlaRadio}>
                        <Radio key={'mla'} value={1}>MLA</Radio>
                        <Radio key={'mp'} value={2}>MP</Radio>
                    </Radio.Group>
                    :
                    (mp
                    ?
                    <Radio.Group value={2}>
                        <Radio key={'mp'} value={2}>MP</Radio>
                    </Radio.Group>
                    :
                    <Radio.Group value={1}>
                        <Radio key={'mla'} value={1}>MLA</Radio>
                    </Radio.Group>
                )}
                <ReactEcharts option={mapOption} notMerge={true} lazyUpdate={true}
                style={{ width: props.mapWidth, height: props.mapHeight }}
                ref={(e) => { echartRef = e; }} />
            </div>
        );
    }
    return <div style={{ width: props.mapWidth, height: props.mapHeight }} />
};